module.exports = __webpack_public_path__ + "894cfc25e269a8ec1ea53083e198ba35.MP3";